// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phases-fair-play-select-setting-modal .modal2__container{
    max-height: 680px;
    max-width: 760px;
}

.phases-fair-play-select-setting-modal__buttons {
    border-top: 1px solid var(--new-gray-background-color);
    padding: 12px 16px;
}

.phases-fair-play-select-setting-modal__buttons .button {
    margin-left: auto;
    padding: 10px 24px;
}

.phases-fair-play-select-setting-modal__container {
    padding: 24px 40px 12px 40px;
    min-height: 250px;
}

.phases-fair-play-select-setting-modal__container .baloa-names.empty-msg {
    color: var(--basic-gray-color);
    text-align: center;
    margin-top: 90px;
}

.phases-fair-play-select-setting-modal__container .infinite-scroll-component  {
    padding-right: 20px;
}

.phases-fair-play-select-setting-modal__option__settings {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 8px;
}

.phases-fair-play-select-setting-modal__radio-options__skeleton {
    border: 1px solid var(--new-gray-background-color);
    padding: 12px 10px;
    border-radius: 6px;
    margin-top: 14px;
    margin-left: 0;
    margin-right: 0;
    display: flex;
    align-items: center;
}

.phases-fair-play-select-setting-modal__radio-options .MuiFormControlLabel-root {
    border: 1px solid var(--new-gray-background-color);
    padding: 12px 10px;
    border-radius: 6px;
    margin-top: 14px;
    margin-left: 0;
    margin-right: 0;
}

.phases-fair-play-select-setting-modal__option__settings .baloa-names {
    color: var(--primary-very-dark-color);
}

.phases-fair-play-select-setting-modal__option__settings .baloa-username {
    color: var(--primary-dark-color);
    display: flex;
    align-items: center;
}

@media screen and (min-width: 1441px) {
    .phases-fair-play-select-setting-modal .modal2__container {        
        max-width: 820px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-phases-fair-play-select-setting-modal/TournamentPhasesFairPlaySelectSettingModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,sDAAsD;IACtD,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".phases-fair-play-select-setting-modal .modal2__container{\n    max-height: 680px;\n    max-width: 760px;\n}\n\n.phases-fair-play-select-setting-modal__buttons {\n    border-top: 1px solid var(--new-gray-background-color);\n    padding: 12px 16px;\n}\n\n.phases-fair-play-select-setting-modal__buttons .button {\n    margin-left: auto;\n    padding: 10px 24px;\n}\n\n.phases-fair-play-select-setting-modal__container {\n    padding: 24px 40px 12px 40px;\n    min-height: 250px;\n}\n\n.phases-fair-play-select-setting-modal__container .baloa-names.empty-msg {\n    color: var(--basic-gray-color);\n    text-align: center;\n    margin-top: 90px;\n}\n\n.phases-fair-play-select-setting-modal__container .infinite-scroll-component  {\n    padding-right: 20px;\n}\n\n.phases-fair-play-select-setting-modal__option__settings {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-top: 8px;\n}\n\n.phases-fair-play-select-setting-modal__radio-options__skeleton {\n    border: 1px solid var(--new-gray-background-color);\n    padding: 12px 10px;\n    border-radius: 6px;\n    margin-top: 14px;\n    margin-left: 0;\n    margin-right: 0;\n    display: flex;\n    align-items: center;\n}\n\n.phases-fair-play-select-setting-modal__radio-options .MuiFormControlLabel-root {\n    border: 1px solid var(--new-gray-background-color);\n    padding: 12px 10px;\n    border-radius: 6px;\n    margin-top: 14px;\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.phases-fair-play-select-setting-modal__option__settings .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.phases-fair-play-select-setting-modal__option__settings .baloa-username {\n    color: var(--primary-dark-color);\n    display: flex;\n    align-items: center;\n}\n\n@media screen and (min-width: 1441px) {\n    .phases-fair-play-select-setting-modal .modal2__container {        \n        max-width: 820px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
